'use strict';

var Mapper = require('./Mapper.js');
var YourDetailsConstants = require('../constants/YourDetailsConstants');
var Formatter = require('../utils/Formatter.js');

var MappingConfigurations = YourDetailsConstants.MappingConfigurations;

var _yourDetailsStore;

var componentsSaveService = {
    savePersonalInfo: function (form, personalInfo) {
        if (!personalInfo) { return; }
        Mapper.objectMerger(form, personalInfo);
    },
    saveResidentialAddressInfo: function (form, addressInfo) {
        if (!addressInfo) { return; }
        if (!addressInfo.isResAddressFound) {
            addressInfo.residential = '';
        }
        form.residentialAddress = Mapper.objectMapperConfigKeysOnly(addressInfo, MappingConfigurations.ResidentialAddressSave);
    },
    savePostalAddressInfo: function (form, addressInfo) {
        if (!addressInfo) { return; }
        if (!addressInfo.isPostalAddressFound) {
            addressInfo.postal = '';
        }
        form.postalAddress = Mapper.objectMapperConfigKeysOnly(addressInfo, MappingConfigurations.PostalAddressSave);
    },
    saveContactDetails: function (form, contactDetails) {
        if (!contactDetails) { return;}
        form.contactDetails = Mapper.objectMapperConfigKeysOnly(contactDetails, MappingConfigurations.ContactSave);
    },
    saveTfn: function (form, tfn) {
        if (!tfn) { return;}
        form.tfnInfo.exemptionReason = tfn.tfnExemptionReason;
        form.tfnInfo.exemptionReasonReadonly = tfn.tfnExemptionReasonReadonly;
        form.tfnInfo.tfnConsentFlag = tfn.tfnConsentFlag;
        form.tfnInfo.tfnNumber = tfn.tfnNumber;
        form.tfnInfo.tfnWithConsent = tfn.tfnWithConsent;
        form.tfnInfo.hasTfnExemption = tfn.hasTfnExemption;
        form.tfnInfo.tfnNumberReadonly = tfn.tfnNumberReadonly;
    },
    saveOtherCountryTaxResidence: function (form, otherCountryTaxResidenceInfo) {
        if (!otherCountryTaxResidenceInfo) { return; }
        form.taxResidence = Mapper.objectMapperConfigKeysOnly(otherCountryTaxResidenceInfo, MappingConfigurations.TaxResidenceSave);
        form.taxResidence.countries = [];
        for (var i = 1; i < 4; i++) {
            if (otherCountryTaxResidenceInfo['otherCountryTaxResidence' + i]) {
                var country = {
                    country: otherCountryTaxResidenceInfo['otherCountryTaxResidence' + i],
                    tin: otherCountryTaxResidenceInfo['tin' + i],
                    tinExemptionReason: otherCountryTaxResidenceInfo['tinExemptionReason' + i],
                    countryReadonly: i === 1 ? otherCountryTaxResidenceInfo['otherCountryTaxResidenceReadonly'] : false
                };
                form.taxResidence.countries.push(country);
            }
        }
    },
    saveCitizenship: function (form, citizenship) {
        if (!citizenship) { return; }
        form.citizenship = Mapper.objectMapperConfigKeysOnly(citizenship, MappingConfigurations.CitizenshipSave);
    },
    saveOccupation: function (form, occupationInfo) {
        if (!occupationInfo) { return; }
        form.occupation = Mapper.objectMapperConfigKeysOnly(occupationInfo, MappingConfigurations.OccupationSave);
    },
    saveIsPowerOfAttorney: function(form, isPowerOfAttorney){
        if (!isPowerOfAttorney) {return;}
        form.isPowerOfAttorney = isPowerOfAttorney;
    },
    saveAccountDesignation: function (form, data) {
        if (!data) { return; }
        form.accountDesignation.isAccountDesignation = data.isAccountDesignation;
        form.accountDesignation.accountDesignationName = data.isAccountDesignation ? data.accountDesignationName : null;
    },
    saveCountryOfResidence: function (form, countryOfResidenceInfo) {
        if (!countryOfResidenceInfo) { return; }
        form.countryOfResidence = Mapper.objectMapperConfigKeysOnly(countryOfResidenceInfo, MappingConfigurations.CountryOfResidenceSave);
    },

    saveBusinessName: function (form, data) {
        if (!data) { return; }
        form.businessName = data.businessName;
        form.businessNameReadonly = data.businessNameReadonly;
    },

    saveSourceOfFund: function (form, data) {
        if (!data) { return; }
        form.sourceOfFund = data.sourceOfFund;
        form.sourceOfFundDescription = Formatter.findSofSow(data.sourceOfFund, _yourDetailsStore.getSourceOfFundList());
        if (data.otherSourceOfFund) {
            form.otherSourceOfFund = data.otherSourceOfFund;
            form.sourceOfFundDescription += (form.sourceOfFundDescription && form.sourceOfFundDescription !== '')
                                            ? ', ' + data.otherSourceOfFund : data.otherSourceOfFund;
        }
    },
    saveSourceOfWealth: function (form, data) {
        if (!data) { return; }
        form.sourceOfWealth = data.sourceOfWealth;
        form.sourceOfWealthDescription = Formatter.findSofSow(data.sourceOfWealth, _yourDetailsStore.getSourceOfWealthList());
        if (data.otherSourceOfWealth) {
            form.otherSourceOfWealth = data.otherSourceOfWealth;
            form.sourceOfWealthDescription += (form.sourceOfWealthDescription && form.sourceOfWealthDescription !== '')
                                              ? ', ' + data.otherSourceOfWealth : data.otherSourceOfWealth;
        }
    },
    saveBusinessAddressInfo: function (form, addressInfo) {
        if (!addressInfo) { return; }
        form.businessAddress = Mapper.objectMapperConfigKeysOnly(addressInfo, MappingConfigurations.ResidentialAddressSave);
    },

    saveBusinessPostalAddressInfo: function (form, addressInfo) {
        if (!addressInfo) { return; }
        form.businessPostalAddress = Mapper.objectMapperConfigKeysOnly(addressInfo, MappingConfigurations.BusinessPostalAddressSave);
    },

    saveAustralianTaxResidence: function(form, data){
        if (!data) { return; }
        form.isAustralianTaxResident = data.isAustralianTaxResident ? data.isAustralianTaxResident : null;        
    },

    saveInvestor: function (mainForm, investorList) {
        var investors = [];
        for (var i = 0; i < investorList.length; i++) {
            if (!investorList[i]) {
                continue;
            }
            var form = this.createInvestorModel();
            form.investorId = i;
            form.oin = investorList[i].oin;
            form.cif = investorList[i].cif;
            componentsSaveService.savePersonalInfo(form, investorList[i]);
            componentsSaveService.saveResidentialAddressInfo(form, investorList[i].addressInfo);
            componentsSaveService.savePostalAddressInfo(form, investorList[i].addressInfo);
            componentsSaveService.saveContactDetails(form, investorList[i]);
            componentsSaveService.saveTfn(form, investorList[i]);
            componentsSaveService.saveCountryOfResidence(form, investorList[i]);
            componentsSaveService.saveOtherCountryTaxResidence(form, investorList[i]);
            componentsSaveService.saveCitizenship(form, investorList[i]);
            componentsSaveService.saveOccupation(form, investorList[i]);
            componentsSaveService.saveIsPowerOfAttorney(form, investorList[i].isPowerOfAttorney);
            componentsSaveService.saveAccountDesignation(form, investorList[i]);
            componentsSaveService.saveAustralianTaxResidence(form, investorList[i]);
            componentsSaveService.saveSourceOfFund(form, investorList[i]);
            componentsSaveService.saveSourceOfWealth(form, investorList[i]);
            investors.push(form);
        }
        mainForm.investorList = investors;
    },

    createInvestorModel: function () {
        return {
            oin: null,
            cif: null,
            kycFlag: null,
            kycType: null,
            investorId: null,
            gender: null,
            title: null,
            givenName: null,
            lastName: null,
            dateOfBirth: null,
            residentialAddress: null,
            postalAddress: null,
            contactDetails: {
                mobile: '',
                home: '',
                work: '',
                email: '',
                withExistingMobileNumber: null
            },
            tfnInfo: {
                tfnNumber: null,
                exemptionReason: null,
                tfnNumberReadonly: null,
                exemptionReasonReadonly: null,
                hasTfnExemption: null,
                tfnConsentFlag: null,
                tfnWithConsent: null
            },
            countryOfResidence: null,
            taxResidence: null,
            citizenship: null,
            occupation: null,
            accountDesignation: {
                isAccountDesignation: null,
                accountDesignationName: null
            },
            titleReadonly: null,
            givenNameReadonly: null,
            lastNameReadonly: null,
            genderReadonly: null,
            dateOfBirthReadonly: null,
            isAustralianTaxResident: null
        };
    },

    savePartnershipName: function (form, data) {
        form.partnershipName = data.partnershipName;
    },
    saveBusinessActivity: function (form, data) {
        form.primaryBusinessActivity = data.primaryBusinessActivity;
        form.primaryBusinessActivityReadonly = data.primaryBusinessActivityReadonly;
    },
    saveCharity: function (form, data) {
        form.isCharity = data.isCharity;
    },
    saveBusinessInvesting: function (form, data) {
        form.isPrimaryBusinessInvesting = data.isPrimaryBusinessInvesting;
    },
    saveCountryEstablished: function (form, data) {
        form.countryEstablished = data.countryEstablished;
        form.countryEstablishedReadonly = data.countryEstablishedReadonly;
    },
    saveAbn: function (form, data) {
        form.abn = data.abn;
        form.abnReadonly = data.abnReadonly;
    },

    saveCompanyName: function (form, data) {
        form.corporateTrustee = data.corporateTrustee;
        form.businessNameReadonly = data.businessNameReadonly;
    },

    saveCorporateTrustee: function (trusteeData, index) {
        var form = {
            corporateTrustee: null,
            abn: null,
            businessAddress: null,
            businessPostalAddress: null,
            oin: null,
            cif: null,
            contactDetails: {
                mobile: '',
                home: '',
                work: '',
                email: '',
                withExistingMobileNumber: null
            },
            trusteeType: YourDetailsConstants.TrusteeType.CORPORATE
        };
        form.trusteeId = index;
        form.oin = trusteeData.oin;
        form.cif = trusteeData.cif;
        componentsSaveService.saveCompanyName(form, trusteeData);
        componentsSaveService.saveBusinessAddressInfo(form, trusteeData.addressInfo);
        componentsSaveService.saveBusinessPostalAddressInfo(form, trusteeData.addressInfo);
        componentsSaveService.saveContactDetails(form, trusteeData);
        componentsSaveService.saveAbn(form, trusteeData);
        return form;
    },
    saveTrustee: function (trusteeData, index) {
        var form = {
            trusteeType: YourDetailsConstants.TrusteeType.INDIVIDUAL,
            gender: null,
            title: null,
            givenName: null,
            lastName: null,
            dateOfBirth: null,
            residentialAddress: null,
            postalAddress: null,
            contactDetails: {
                mobile: '',
                home: '',
                work: '',
                email: '',
                withExistingMobileNumber: null
            },
            tfnInfo: {
                tfnNumber: null,
                exemptionReason: null,
                hasTfnExemption: null
            },
            countryOfResidence: null,
            isAustralianTaxResident: null,
            taxResidence: null,
            citizenship: null,
            occupation: null,
            kycFlag: null,
            kycType: null,
            kycSetFromCommSee: null,
            titleReadonly: null,
            givenNameReadonly: null,
            lastNameReadonly: null,
            genderReadonly: null,
            dateOfBirthReadonly: null,
            oin: null,
            cif: null
        };
        form.trusteeId = index;
        form.oin = trusteeData.oin;
        form.cif = trusteeData.cif;
        componentsSaveService.savePersonalInfo(form, trusteeData);
        componentsSaveService.saveResidentialAddressInfo(form, trusteeData.addressInfo);
        componentsSaveService.savePostalAddressInfo(form, trusteeData.addressInfo);
        componentsSaveService.saveContactDetails(form, trusteeData);
        componentsSaveService.saveTfn(form, trusteeData);
        componentsSaveService.saveCountryOfResidence(form, trusteeData);
        componentsSaveService.saveOtherCountryTaxResidence(form, trusteeData);
        componentsSaveService.saveCitizenship(form, trusteeData);
        componentsSaveService.saveOccupation(form, trusteeData);

        return form;
    },
    saveTrustees: function (mainForm, trusteeList) {
        var trustees = [];
        for (var i = 0; i < trusteeList.length; i++) {
            if (!trusteeList[i]) {
                continue;
            }
            if (trusteeList[i].trusteeType === YourDetailsConstants.TrusteeType.CORPORATE) {
                trustees.push(this.saveCorporateTrustee(trusteeList[i], i));
            }
            else {
                trustees.push(this.saveTrustee(trusteeList[i], i));
            }
        }
        mainForm.trusteeList = trustees;
    }
}

function saveFunction() {
    var form = YourDetailsConstants.Properties.Form;
    var yourDetailsData = _yourDetailsStore.getYourDetailsData();
    componentsSaveService.savePersonalInfo(form, yourDetailsData);
    componentsSaveService.saveResidentialAddressInfo(form, _yourDetailsStore.getAddressInfo());
    componentsSaveService.savePostalAddressInfo(form, _yourDetailsStore.getAddressInfo());
    componentsSaveService.saveContactDetails(form, yourDetailsData);
    componentsSaveService.saveTfn(form, yourDetailsData);
    componentsSaveService.saveOtherCountryTaxResidence(form, yourDetailsData);
    componentsSaveService.saveCitizenship(form, yourDetailsData);
    componentsSaveService.saveOccupation(form, yourDetailsData);
    componentsSaveService.saveCountryOfResidence(form, yourDetailsData);
    componentsSaveService.saveBusinessName(form, yourDetailsData);
    componentsSaveService.saveBusinessAddressInfo(form, _yourDetailsStore.getBusinessAddressInfo());
    componentsSaveService.saveInvestor(form, _yourDetailsStore.getInvestorList());
    componentsSaveService.savePartnershipName(form, yourDetailsData);
    componentsSaveService.saveBusinessActivity(form, yourDetailsData);
    componentsSaveService.saveCharity(form, yourDetailsData);
    componentsSaveService.saveBusinessInvesting(form, yourDetailsData);
    componentsSaveService.saveCountryEstablished(form, yourDetailsData);
    componentsSaveService.saveAbn(form, yourDetailsData);
    componentsSaveService.saveTrustees(form, _yourDetailsStore.getTrusteeList());
    componentsSaveService.saveAccountDesignation(form, yourDetailsData);
    componentsSaveService.saveSourceOfFund(form, yourDetailsData);
    componentsSaveService.saveSourceOfWealth(form, yourDetailsData);
    return form;
}

module.exports = {
    componentsSaveService: componentsSaveService,
    save: function (yourDatailsStore) {
        _yourDetailsStore = yourDatailsStore; //so that this module doesn't have to reference  yourDetailsStore which causing circular dependencies
        return saveFunction();
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/YourDetailsSave.js